
// src/web/components/template-form-panel.jsx

import React from 'react'
import connect from '../../connects/template-form-panel'
import {
  Card,
  CardText,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import {
  List,
  ListItem,
  ListItemContent,
  ListDivider,
} from 'react-toolbox/lib/list'
import Checkbox from 'react-toolbox/lib/checkbox';
import DropDown from 'react-toolbox/lib/dropdown'
import FontIcon from 'react-toolbox/lib/font_icon'
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc'
import TimePickerDialog from './time-picker-dialog.jsx'
import ImportTemplateSelectionDialog from './import-template-selection-dialog.jsx'
import theme from './themes/flat-card.css'
import {
  Input,
} from 'react-toolbox/lib/input'
import RichTextEditor from './rich-text-editor.jsx'
import ConfirmDialog from './confirm-dialog.jsx'
import {
   linkUI 
} from '../../helpers/form-validator'
import { translate } from 'react-i18next'
import successButtonTheme from './themes/success-button.css'
import fieldListItemTheme from './themes/field-edit-list-item.css'
import sortableTheme from './themes/sortable.css'
import FIELD_ICONS from '../../helpers/field-icons'
import numRegex from '../../helpers/number-regexp'

@SortableHandle
class DragHandler extends React.Component {
  render() {
    return <FontIcon value='drag_indicator' style={{ cursor: 'move' }} />
  }
}

@translate()
@SortableElement
class FieldItem extends React.Component {
  state = { editing: false, timepick: false }

  onEdit = ()=> {
    this.setState({ editing: true })
    this.props.onStartEdit()
  }
  onOk = ()=> {
    if (this.props.validateField()) {
      this.setState({ editing: false })
      this.props.onEndEdit()
    }
  }

  onTypeChange = (value)=> this.props.updateField(Object.assign({}, this.props.field, { type: value, value: undefined, options: [] }))
  onNameChange = (value)=> this.props.updateField(Object.assign({}, this.props.field, { name: value.trim() }))
  onRequiredChange = (value)=> this.props.updateField(Object.assign({}, this.props.field, { required: !!value }))
  onOptionsChange = (value)=> this.props.updateField(Object.assign({}, this.props.field, { options: value.split(/[\n\r]/) }))
  onValueChange = (value)=> this.props.updateField(Object.assign({}, this.props.field, { value: this.props.field.type == 'numeric' ? parseFloat(value || 0): value }))
  onTimeValueChange = (value)=> {
    this.toggleTimePicker()
    this.props.updateField(Object.assign({}, this.props.field, { value: value }))
  }
  toggleTimePicker = ()=> this.setState({ timepick: !this.state.timepick })

  componentDidMount() {
    if (this.props.field.type == 'new') {
      this.setState({ editing: true })
      this.props.onStartEdit()
    }
  }

  render() {
    const {
      t,
      index,
      field,
      fieldError,
      updateField,
      deleteField,
      validateField,
    } = this.props

    const TYPES = [
      { value: 'string',  label: t('label:form-string') },
      { value: 'numeric', label: t('label:form-numeric') },
      { value: 'text', label: t('label:form-text') },
      { value: 'date', label: t('label:form-date') },
      { value: 'time', label: t('label:form-time') },
      { value: 'dropdown', label: t('label:form-dropdown') },
    ]

    if (this.state.editing)
      return (
        <ListItem selectable={false} ripple={false} theme={fieldListItemTheme} leftIcon={<DragHandler />} >
          <ListItemContent>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div style={{ width: '200px', marginRight: '10px' }}>
                <DropDown key={1} error={field.type == 'new' && t('error:フィールド種別を選択してください')} label={t('label:フィールド種別')} source={TYPES} value={field.type} onChange={this.onTypeChange} />
              </div>
              <div style={{ flexGrow: 1 }}>
                <Input label={t('label:フィールド名')} hint={t('label:新しいフィールド')} value={field.name} error={fieldError.name} onChange={this.onNameChange} />
              </div>
              {field.type == 'dropdown' && field.options && field.options.length > 0 &&
                <div style={{ alignSelf: 'center', flexGrow: 0.5, marginLeft: '10px' }}>
                  <DropDown label={t('label:初期値を指定します')}
                    source={field.options.map((option)=> ({ value: option, label: option }))}
                    value={field.value}
                    onChange={this.onValueChange} />
                </div>
              }
              {field.type == 'time' && 
                <div style={{ alignSelf: 'center', flexGrow: 0.5, marginLeft: '10px' }}>
                  <Button label={field.value && t('label:初期値', { value: field.value }) || t('label:初期値を指定します')}
                    onClick={this.toggleTimePicker} style={{ width: '100%' }} raised />
                </div>
              }
            </div>
            {field.type == 'dropdown' &&
              <Input multiline rows={5} 
                label={t('label:フィールドの選択肢')}
                hint={t('label:ドロップダウン入力の場合の選択肢を改行で区切って列挙します')}
                error={fieldError.options}
                value={(field.options || []).join('\n')}
                onChange={this.onOptionsChange} />
            }
            {(field.type == 'string' || field.type == 'numeric') &&
              <Input label={t('label:初期値を指定します')}
                type={field.type == 'string' ? 'text' : 'number'}
                value={field.value}
                onChange={this.onValueChange} />
            }
            {field.type == 'text' &&
              <Input label={t('label:初期値を指定します')}
                multiline rows={5}
                value={field.value}
                onChange={this.onValueChange} />
            }
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
              <Checkbox label={t('label:必須')} checked={field.required} theme={fieldListItemTheme} onChange={this.onRequiredChange} />
              <Button label={t('label:削除')} mini raised icon='delete' onClick={deleteField} />&nbsp;
              <Button label={t('label:OK')} mini primary raised onClick={this.onOk} />
            </div>
            <TimePickerDialog active={this.state.timepick}
              value={field.value}
              okLabel={t('label:OK')}
              cancelLabel={t('label:取り消し')}
              onSelect={this.onTimeValueChange}
              onCancel={this.toggleTimePicker} />
          </ListItemContent>
        </ListItem>
      )
    else
      return (
        <ListItem leftIcon={<DragHandler />} ripple selectable theme={fieldListItemTheme} className="easyInputText"
          caption={field.name}
          legend={(field.type == 'dropdown' ? field.options.join(', ') : t(`label:form-${field.type}`)) + (field.value ?  field.type == 'numeric' &&  ` - ${numRegex(field.value)}` ||  ` - ${field.value}` : '') + (field.required ? ` - ${t('label:必須')}` : '')}
          onClick={this.onEdit} />
      )
  }
}

@translate()
@SortableContainer
class FieldList extends React.Component {
  state = { disabled: false }

  onStartEdit = ()=> this.setState({ disabled: true })
  onEndEdit = ()=> this.setState({ disabled: false })

  render() {
    const {
      fields, 
      fieldsError,
      updateField,
      validateField,
      deleteField,
    } = this.props

    return (
      <List>
        {_.map(fields, (field, i)=> 
          <FieldItem key={i} index={i} field={field} fieldError={fieldsError[i] || {}}
            disabled={this.state.disabled}
            onStartEdit={this.onStartEdit}
            onEndEdit={this.onEndEdit}
            updateField={(field)=> updateField(i, field)}
            validateField={()=> validateField(i)}
            deleteField={()=> deleteField(i)} />
        )}
      </List>
    )
  }
}

class TemplateFormPanel extends React.Component {
  state = { templateSelection: false, confirmDialog: false, template: undefined }
  addField = ()=> this.props.addField(this.props, {
    name: '',
    type: 'new',
    required: false,
  })
  updateField = (index, field)=> this.props.updateField(this.props, index, field)
  deleteField = (index)=> this.props.deleteField(this.props, index)
  validateField = (index)=> this.props.validateField(this.props, index)
  onSortEnd = ({ oldIndex, newIndex })=> {
    this.props.sortField(this.props,
      arrayMove(this.props.ui.fields, oldIndex, newIndex),
      arrayMove(this.props.ui.fieldsError, oldIndex, newIndex)
    )
  }
  onEditorInitialized = (handlers)=> {
    this.props.updateUI({ handlers })
    this.props.template && setTimeout(()=> handlers.insertValue(this.props.template.template), 0)
  }
  toggleConfirmDialog = ()=> this.setState({ confirmDialog: !this.state.confirmDialog })
  toggleTemplateSelectionDialog = ()=> this.setState({ templateSelection: !this.state.templateSelection })
  onTemplateSelect = (template)=> this.setState({
    templateSelection: false,
    confirmDialog: true,
    template: template,
  })
  onTemplateConfirmed = ()=> {
    this.toggleConfirmDialog()
    this.props.pasteTemplate(this.props, this.state.template)
  }

  onChangeCategory = (category) => this.props.onChangeCategory(this.props,　category)

  render() {
    const {
      t,
      ui,
      template,
      isUpdating,
      updateUI, 
      validateAndSubmit,
      addField,
      updateField,
      deleteField,
      validateField,
      addCategory,
      pasteTemplate,
      onChangeCategory,
    } = this.props

    const CATEGORY =[
      { value: 'diary', icon: 'event_note' },
      { value: 'kpi', icon: 'insert_chart' },
      { value: 'memo', icon: 'assignment' }
    ]

    return (
      <Card theme={theme}>
        <CardText>
          <Button raised theme={successButtonTheme}
            icon='get_app'
            onClick={this.toggleTemplateSelectionDialog}
            label={t('label:テンプレートをインポート')} />
        </CardText>

        <form onSubmit={(e) => validateAndSubmit(this.props, e)}>
          <CardText>
            <normal><strong>{t('label:テンプレート名')}</strong></normal>
            <Input name="name" required
              label={t('label:テンプレート名')}
              value={ui.name}
              icon="edit"
              error={ui.nameError && t('error:テンプレート名を入力してください')}
              onChange={linkUI(this, 'name')} />
          </CardText>

          <CardText>
            <normal><strong>{t('label:投稿種別')}</strong></normal>
            <DropDown
              source={CATEGORY}
              value={ui.category}
              template={(item)=> <span>&nbsp;<FontIcon value={item.icon} style={{ verticalAlign: 'bottom' }}/>&nbsp;{t('diary:' + item.value)}</span>}
              onChange={this.onChangeCategory} />
          </CardText>

          <CardText>
            <normal><strong>{t('label:内容')}</strong></normal><br />
            <RichTextEditor editTemplate={true}
                placeholder={t("label:テンプレートを作成しましょう")}
                onEditorInitialized={this.onEditorInitialized} />
          </CardText>

          <CardText>
            <normal><strong>{t('label:入力フィールド')}</strong></normal>
            <FieldList useDragHandle
              helperClass={sortableTheme.sortable}
              onSortEnd={this.onSortEnd}
              hideSortableGhost={false}
              fields={ui.fields}
              fieldsError={ui.fieldsError}
              updateField={this.updateField}
              validateField={this.validateField}
              deleteField={this.deleteField} />
            <Button label={t('label:フィールドを追加')} style={{ width: '100%' }}
              icon='add_box' onClick={this.addField} raised />
          </CardText>

          <CardActions>
            <Button raised primary
              disabled={isUpdating}
              type="submit"
              style={{ width: '100%' }}
              label={template && template.template_id ? t('label:更新') : t('label:登録')} />
          </CardActions>
        </form>
        <ImportTemplateSelectionDialog active={this.state.templateSelection}
          onClose={this.toggleTemplateSelectionDialog}
          onTemplateSelect={this.onTemplateSelect} />
        <ConfirmDialog open={this.state.confirmDialog}
          title={t('label:テンプレートを上書きしていいですか')}
          yesLabel={t('label:上書き')}
          noLabel={t('label:取り消し')}
          onNo={this.toggleConfirmDialog}
          onYes={this.onTemplateConfirmed} />
      </Card>
    )
  }
}

export const RawTemplateFormPanel = TemplateFormPanel
export default connect(TemplateFormPanel)



// WEBPACK FOOTER //
// ./src/web/components/template-form-panel.jsx